// extracted by mini-css-extract-plugin
export default {"titleContainer":"titleContainer-Oy7jZsGN7GafAR2TKwFj","iconPmr":"iconPmr-H336aSob8GBYNlUTFAx2"};